import React from 'react';
import './styles.css';

import { Text } from "@fragments";

// Base StatusChip component
const StatusChip = ({ text, variant = 'default', className = '', icon = null }) => {
  return (
    <Text.span
      weight={300}
      className={`status-chip ${variant} ${className} ${
        icon ? 'status-chip--with-icon' : ''
      }`.trim()}
    >
      {icon ? <span className="status-chip__icon">{icon}</span> : null}
      {text}
    </Text.span>
  );
};

// Main status variants
StatusChip.Success = ({ text, className = '', icon = null }) => (
  <StatusChip text={text} variant="success" className={className} icon={icon} />
);

StatusChip.Error = ({ text, className = '', icon = null }) => (
  <StatusChip text={text} variant="error" className={className} icon={icon} />
);

StatusChip.Default = ({ text, className = '', icon = null }) => (
  <StatusChip text={text} variant="default" className={className} icon={icon} />
);

StatusChip.Alert = ({ text, className = '', icon = null }) => (
  <StatusChip text={text} variant="alert" className={className} icon={icon} />
);

StatusChip.Info = ({ text, className = '', icon = null }) => (
  <StatusChip text={text} variant="info" className={className} icon={icon} />
);

export default StatusChip;